import { css } from 'lit';
import { color } from '../../css.helper';

export const TmHighlightElementStyle = [
  css`
    span.highlighted-text {
      background-color: ${color('orange', 300)};
    }
  `,
];
